var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2Location(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 32a16.84 16.84 0 10-30.27 10.2l13.4 20.72 13.62-21a16.793 16.793 0 001.6-2.71A16.74 16.74 0 0055 32zm-16.87 6.59a7 7 0 110-14.002 7 7 0 010 14.002z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Location.c0a9d9ef.svg";
export { SvgJ2Location as ReactComponent };